<template>
  <div class="container-fluid">
    <br />
    <b-row v-if="user">
      <b-col class="col-sm-12 col-xl-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Usuário
          </div>
          <div class="card-body">
            <ul class="list-group">
              <li class="list-group-item">Nome: {{user.name}}</li>
              <li class="list-group-item">Email: {{user.email}}</li>
              <li class="list-group-item">
                Whatsapp:
                <a
                  target="_blank"
                  v-bind:href="'https://api.whatsapp.com/send?l=pt_BR&phone=55' + user.whatsapp"
                >{{user.whatsapp}}</a>
              </li>
              <li class="list-group-item">
                Instagram:
                <a
                  target="_blank"
                  v-bind:href="'https://instagram.com/' + user.instagram"
                >{{user.instagram}}</a>
              </li>
            </ul>
          </div>
        </div>
      </b-col>
      <b-col class="col-sm-12 col-xl-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-edit"></i> Templates Utilizados
          </div>
          <spinner v-if="loadingData"/>
          <b-card
            v-if="items && items.length > 0 && !loadingData">
            <table class="table table-responsive-sm">
              <thead>
                <tr>
                  <th>Instagram</th>
                  <th>Contador de Usos</th>
                  <th>Relevância</th>
                  <th>Express</th>
                  <th>Avançado</th>
                </tr>
              </thead>
              <tbody>
                <div v-for="(item, index) in items" v-bind:key="index">
                  <tr v-if="item && item._id">
                    <td>
                      <img v-bind:src="item.thumbnail" height="100" width="100" />
                    </td>
                    <td>{{item.countUse > 0 ? item.countUse : 0}}</td>
                    <td>{{item.weight}}</td>
                    <td>{{item.expressEdition == true ? "Sim" : "Não"}}</td>
                    <td>{{item.advancedEdition == true ? "Sim" : "Não"}}</td>
                  </tr>
                </div>
              </tbody>
            </table>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <br />
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";

export default {
  name: "UserEdition",

  data: () => {
    return {
      userId: "",
      items: [],
      user: {},
      loadingData: false,
    };
  },
  methods: {
    getTemplatesInfo: function() {
      this.items = [];
      this.loadingData = true;
      service
        .getTemplateEdition({
           idUser: this.userId
        })
        .then(response => {
          this.loadingData = false;
          this.items = response.templates;
          this.totalTemplates = response.totalItens;
        });
    },
    getUser: function() {
      this.loadingData = true;
      service.getUser(this.userId).then(response => {
        this.loadingData = false;
        this.user = response.user;
        this.name = this.user.name;
        this.email = this.user.email;
        this.getTemplatesInfo();
      });
    }
  },
  components: { Spinner },
  created() {
    this.userId = this.$route.params.id;
    this.getUser();
  }
};
</script>


